import * as React from 'react';
import { isSuburban, offerTypeFromJsonQuery } from '../../../../../utils/category';
import { trackBannerKpLinkClick, trackTrapKpLinkClick } from '../../utils/tracking';
import { LinkButton } from '@cian/ui-kit/button';
import { QuickLinksTitle } from '../QuickLinksTitle';
import { QuickLinksBanner } from '../QuickLinksBanner';
import { IQuickLinksProps } from '../../QuickLinks';
import * as styles from './QuickLinksSuburbanTrap.css';
import { ArrowOut16 } from '@cian/ui-kit/icons';

type TQuickLinksSuburbanTrapProps = Pick<
  IQuickLinksProps,
  'isCountrysideTrapEnabled' | 'countrysideLink' | 'jsonQuery'
>;

export function QuickLinksSuburbanTrap({
  isCountrysideTrapEnabled,
  countrysideLink,
  jsonQuery,
}: TQuickLinksSuburbanTrapProps) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isSuburbanListing = isSuburban(offerType);

  if (!isSuburbanListing) {
    return null;
  }

  if (isCountrysideTrapEnabled) {
    return (
      <QuickLinksBanner hasLeftBorder>
        <QuickLinksTitle>
          Дома и участки{' '}
          <a href={countrysideLink} onClick={trackTrapKpLinkClick} className={styles['link']}>
            в посёлках <ArrowOut16 width="22" color="primary_100" />
          </a>
        </QuickLinksTitle>
        <div className={styles['content']}>Здесь больше информации про застройщика и условия проживания.</div>
      </QuickLinksBanner>
    );
  }

  return (
    <QuickLinksBanner hasLeftBorder>
      <QuickLinksTitle>Дома и участки в коттеджных посёлках</QuickLinksTitle>
      <div className={styles['content']}>
        <LinkButton size="XS" theme="fill_secondary" href={countrysideLink} onClick={trackBannerKpLinkClick}>
          Посмотреть
        </LinkButton>
      </div>
    </QuickLinksBanner>
  );
}
